/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbraco Delivery API
 * You can find out more about the Umbraco Delivery API in [the documentation](https://docs.umbraco.com/umbraco-cms/reference/content-delivery-api).
 * OpenAPI spec version: Latest
 */

export type ButtonUmbBlockElementModelContentType =
	(typeof ButtonUmbBlockElementModelContentType)[keyof typeof ButtonUmbBlockElementModelContentType];

export const ButtonUmbBlockElementModelContentType = {
	buttonUmbBlock: "buttonUmbBlock",
} as const;
